import { ColumnDef } from "@tanstack/react-table";
import { Link } from "react-router";
import { Routes } from "@/config/routes";
import { GroupIcon, MapPin } from "lucide-react";

export const Columns: ColumnDef<Dryp.StructureGroup>[] = [
	{
		accessorKey: "name",
		header: "Name",
		cell: ({ row }) => {
			const { name } = row.original;
			return (
				<div className="flex gap-2">
					<GroupIcon className="h-4 w-4 text-blue-400" />
					{name}
				</div>
			);
		},
	},
	{
		accessorKey: "structureCount",
		header: "Structures count",
	},
	{
		accessorKey: "map",
		header: "Map",
		enableSorting: false,
		enableHiding: false,
		cell: ({ row }) => {
			const { id } = row.original;

			return (
				<Link
					to={`${Routes.Dashboard.Map.build({}, { groups: [id] })}`}
					className="text-blue-600 hover:text-blue-800 transition"
					title="View on Map"
				>
					<MapPin className="w-4 h-4" />
				</Link>
			);
		},
	},
];
